<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <OrientationModuleAssignmentListing />

    </Layout>
</template>
<script>
import Layout from "@/views/layouts/main";
import PageHeader from "@/components/page-header";
import i18n from "@/i18n";
import OrientationModuleAssignmentListing from "@/views/pages/admin/orientationModuleAssignment/orientationModuleAssignmentListing";

export default {
    page: {
        title: i18n.t("module.assignment"),
    },
    components: { Layout, PageHeader, OrientationModuleAssignmentListing },
    data() {
        return {
            title: i18n.t("module.assignment"),
            items: [
                {
                    text: i18n.t("module.orientation"),
                    href: '/orientations',
                },
                {
                    text: i18n.t("module.assignment"),
                    active: true,
                },
            ],
        };
    },
}
</script>
